<template>
  <div class="page" :class="{ 'page__has-bar': !canAccept }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.in_code }}</em>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.ind_vendname">
            <label class="weui-form-preview__label">供应商</label>
            <em class="weui-form-preview__value">{{ form.ind_vendname }}</em>
          </div>
          <div class="weui-form-preview__item" v-if="form.in_tel">
            <label class="weui-form-preview__label">联系人</label>
            <span class="weui-form-preview__value"
              >{{ form.in_contact }} {{ form.in_tel }}</span
            >
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">询价日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.in_startdate
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">截止日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{ form.in_enddate }}</span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料</label>
            <span class="weui-form-preview__value">{{ form.pr_code }} {{ form.pr_detail }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.pr_orispeccode">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{
              form.pr_orispeccode
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.pr_spec">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{ form.pr_spec }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.pr_brand">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <span class="weui-form-preview__value">{{ form.pr_brand }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="canAccept">
            <label class="weui-form-preview__label">报价</label>
            <span class="weui-form-preview__value" v-html="priceDesc"></span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币种</label>
            <span class="weui-form-preview__value">
              {{ form.ind_currency }}
              <span v-if="form.ind_rate && form.ind_rate != 1">
                / {{ form.ind_rate }}</span
              >
            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">税率</label>
            <span class="weui-form-preview__value">
              {{ form.ind_taxrate }}
            </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.pr_purcprice">
            <label class="weui-form-preview__label">上次购价</label>
            <span class="weui-form-preview__value" v-format="'#,##0.#'">{{ form.pr_purcprice }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.ind_delivery">
            <label class="weui-form-preview__label">交期天数</label>
            <span class="weui-form-preview__value">{{ form.ind_delivery }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.ind_minqty">
            <label class="weui-form-preview__label">最小包装数</label>
            <span class="weui-form-preview__value">{{ form.ind_minqty }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.ind_minbuyqty">
            <label class="weui-form-preview__label">最小起订量</label>
            <span class="weui-form-preview__value">{{ form.ind_minbuyqty }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.ind_remark">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{ form.ind_remark }}</span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview" v-if="form.in_remark">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{ form.in_remark }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="canAccept">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="accept"
        >采纳</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="refuse"
        >拒绝</a
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        priceDetails: [],
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.form = to.params.initData;
      console.log(from, to, vm);
    });
  },
  computed: {
    /**
     * 采纳状态
     */
    canAccept() {
      const form = this.form;

      return form.filterMode === 20
      // if (!form || !form.in_vendname) {
      //   return false;
      // }
      // const priceList = form.priceDetails;
      // if (!priceList || !priceList.length) {
      //   return false;
      // }
      // return !priceList[priceList.length - 1].ipd_status;
    },
    /**
     * 价格描述
     */
    priceDesc() {
      const priceList = this.form.priceDetails || [];
      return priceList
        .map((i) => i.ipd_lapqty + "+¥" + i.ipd_price)
        .join("<br>");
    },
  },
  methods: {
    accept() {
      var me = this,
        form = me.form,
        data = {
          b2bCode: form.b2bCode,
          currency: form.ind_currency,
          deliveryDays: form.ind_delivery,
          indid: form.ind_id,
          minbuyqty: form.ind_minbuyqty,
          minqty: form.ind_minqty,
          priceDetails: form.priceDetails,
          qdRemark: form.qd_remark,
          quRemark: form.qu_remark,
          sourceId: form.qd_id,
          taxrate: form.ind_taxrate,
          vendId: form.ind_vendid,
          vendcode: form.ind_vendcode,
          vendname: form.ind_vendname,
        };
      me.$loading({
        url: "/api/purchase/inquiry/accept",
        method: "POST",
        jsonData: data,
      })
        .then(function (res) {
          if (res.success) {
            me.$weui.toast("采纳成功", 2000);
            me.$router.back();
          } else {
            me.$weui.topTips(res.message, 3000);
          }
        })
        .catch(function () {
          me.$weui.topTips("采纳失败", 3000);
        });
    },
    refuse() {
      var me = this,
        form = me.form,
        data = {
          b2bCode: form.b2bCode,
          indid: form.ind_id,
          minqty: form.ind_minqty,
          minbuyqty: form.ind_minbuyqty,
          deliveryDays: form.ind_delivery,
          priceDetails: form.priceDetails,
          vendname: form.in_vendname,
        };
      me.$loading({
        url: "/api/purchase/inquiry/refuse",
        method: "POST",
        jsonData: data,
      })
        .then(function (res) {
          if (res.success) {
            me.$weui.toast("拒绝成功", 2000);
            me.$router.back();
          } else {
            me.$weui.topTips(res.message, 3000);
          }
        })
        .catch(function () {
          me.$weui.topTips("拒绝失败", 3000);
        });
    },
  },
};
</script>